import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught about the custom scales declared in `tokens.css`
 * so `cn('text-2xs', 'text-sm')` and `cn('shadow-page', 'shadow-lg')` collapse correctly.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-2xs'],
      shadow: ['shadow-sheet', 'shadow-ring', 'shadow-page'],
      rounded: ['rounded-3xl'],
    },
  },
});

/** Conditional class names + Tailwind conflict resolution. The only class helper in the app. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
